import BackIcon from 'assets/images/rectangle/east.svg'
import classNames from 'classnames'
import { useLocation, useNavigate } from 'react-router-dom'
interface IHeaderProps {
    title: string
    isGreen?: boolean
}
export default function Header({ title, isGreen = false }: IHeaderProps) {
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const isCallback = pathname.includes('gateway-callback/')
    return (
        <div
            className={classNames(
                ' w-full px-2 py-3 flex sticky top-0 z-10  items-center',
                !isCallback ? 'justify-between' : 'justify-center'
            )}
        >
            {!isCallback && (
                <img
                    src={BackIcon}
                    alt="back"
                    onClick={() => navigate(-1)}
                    className={classNames(
                        ' cursor-pointer',
                        isGreen ? 'text-green-1' : 'text-black'
                    )}
                />
            )}
            <p className={classNames(isGreen ? 'text-green-1' : 'text-black')}>
                {title}
            </p>
            <div></div>
        </div>
    )
}
